module.exports = __webpack_public_path__ + "img/Zulu-logo.fb4f62ea.svg";